"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CheckmarkCircleSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var CheckmarkCircleSVG = function CheckmarkCircleSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6.7,9.58-9,9.82a1,1,0,0,1-1.44,0L8.8,17.53a1.08,1.08,0,0,1,0-1.48,1,1,0,0,1,1.41,0L13,19.19l8.3-9.09a1,1,0,0,1,1.41,0A1.08,1.08,0,0,1,22.7,11.58Z"
  }));
};
exports.CheckmarkCircleSVG = CheckmarkCircleSVG;
CheckmarkCircleSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(CheckmarkCircleSVG);
exports.default = _default;